import { get } from "utils/lodash";
export const CAMPAIGN_PACKAGE_SELECTION = `
    id
    discountType
    discountValue
    displayDiscountPrice
    name
    displayName
    subShopCategories {
        code
        name
        id
    }
      
      ward {
        id
        name
        wardCode
        provinceCode
      }
    
    shop {
        id
        name
        slug
        displayedAddress
        openHour
        closeHour
        rating
        allowBooking
        location
        avatar {
            url
            alt
        }
        shopChain {
            headOffice {
                id
                name
                displayedAddress
            }
            shops {
                id
                name
                displayedAddress
                avatar {
                    url
                    alt
                }
            }
        }
        bookingDayOfWeek {
            dayOfWeek
            startTime
            endTime
            timeGap
            bookingNumberLimit
        }
    }
    service {
        id
        name
        menuPrice
        duration
        description
    }
    campaign {
        name
        startDate
        endDate
        condition
        gallery {
            url
            alt
            sizes {
                card {
                    url
                }
                thumbnail {
                    url
                }
            }
        }
        relatedCampaignPackages {
          docs {
            id
            name
            displayName
            shop {
                id
                name
                displayedAddress
            }
          }
        }
    }
`;

export const CAMPAIGN_PACKAGE_CARD_SELECTION = `
   id
    discountType
    discountValue
    displayDiscountPrice
    name
    displayName
    subShopCategories {
        code
        name
        id
    }
    ward {
        id
        name
        wardCode
        provinceCode
      }
    shop {
        id
        name
        slug
        displayedAddress
        openHour
        closeHour
        rating
        allowBooking
        location
        avatar {
            url
            alt
        }
        shopChain {
            headOffice {
                id
                name
                displayedAddress
            }
            shops {
                id
                name
                displayedAddress
                avatar {
                    url
                    alt
                }
            }
        }
        bookingDayOfWeek {
            dayOfWeek
            startTime
            endTime
            timeGap
            bookingNumberLimit
        }
    }
    service {
        id
        name
        menuPrice
        duration
        description
    }
`;

/** Selection gọn cho gói khuyến mãi theo khung giờ (type = slot) — section "Săn giờ đẹp" + trang shop */
export const CAMPAIGN_PACKAGE_SLOT_SELECTION = `
    id
    type
    name
    isExpired
    promotionStatus
    dayOfWeek
    startTime
    endTime
    discountType
    discountValue
    startDate
    endDate
    shop {
        id
    }
`;

/**
 * where lọc gói còn hiệu lực ở phía server (isExpired/promotionStatus là field virtual → không filter được).
 * Dùng field thật: status=available + isDisplay + khoảng ngày.
 *
 * Lưu ý: gói có startDate/endDate = null sẽ bị loại (so sánh ngày với null = false).
 * Đã kiểm data prod 09/10/2026: 0/66 gói available+isDisplay (55 service, 11 slot) thiếu ngày
 * → chưa cần fallback. Nếu BE sau này cho phép gói không giới hạn ngày, thêm nhánh OR { startDate: null }.
 */
export const activeCampaignPackageWhere = (
  type: "service" | "slot",
  opts: { shopId?: string; now?: Date } = {},
) => {
  // Làm tròn "now" xuống phút: biến where không đổi trong 1 phút → các cơ chế
  // cache theo khoá (Next fetch cache, React cache(), CMS) mới trùng khoá được;
  // mili-giây lệch nhau khiến mọi lần gọi đều là khoá mới.
  const now = new Date(opts.now || Date.now());
  now.setSeconds(0, 0);
  const iso = now.toISOString();
  return {
    AND: [
      { type: { equals: type } },
      ...(opts.shopId ? [{ shop: { equals: opts.shopId } }] : []),
      { status: { equals: "available" } },
      { isDisplay: { equals: true } },
      { startDate: { less_than_equal: iso } },
      { endDate: { greater_than: iso } },
    ],
  };
};

/** isExpired/promotionStatus là field virtual — BE có thể đánh dấu hết hạn dù còn trong khoảng ngày */
export const isCampaignPackageLive = (p: unknown) =>
  !get(p, "isExpired") && get(p, "promotionStatus") !== "expired";
